import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
} from 'firebase/app-check';

// -----------------------------------
// Main LumoChart Firebase project
// -----------------------------------
const lumochartConfig = {
  apiKey: "AIzaSyBQwtYWljdzutNP2cAje-CTZ6r_y2XLbQE",
  authDomain: "lumochart.firebaseapp.com",
  projectId: "lumochart",
  storageBucket: "lumochart.appspot.com",
  messagingSenderId: "457820385859",
  appId: "1:457820385859:web:d06ec33c61cc5504fbdaf6",
};

// -----------------------------------
// Separate Lumosye Staffing Firebase project
// -----------------------------------
const staffingConfig = {
  apiKey: "AIzaSyADIlqrkShMV9Ger3pPjS1tDty4OI9dhcw",
  authDomain: "lumosye-staffing.firebaseapp.com",
  projectId: "lumosye-staffing",
  storageBucket: "lumosye-staffing.firebasestorage.app",
  messagingSenderId: "536764657199",
  appId: "1:536764657199:web:8dbcaa047ce3d4cfa860da",
};

const lumochartApp = initializeApp(lumochartConfig, 'lumochart');
const staffingApp = initializeApp(staffingConfig, 'staffing');

// LumoChart
export const auth = getAuth(lumochartApp);
export const db = getFirestore(lumochartApp);
export const storage = getStorage(lumochartApp);

// Staffing
export const staffingAuth = getAuth(staffingApp);
export const staffingDb = getFirestore(staffingApp);
export const staffingStorage = getStorage(staffingApp);
export const staffingFunctions = getFunctions(staffingApp);

// App Check for staffing site only
export const staffingAppCheck = initializeAppCheck(staffingApp, {
  provider: new ReCaptchaV3Provider('6LcDQ5UsAAAAAKvjQtH0bUX9g-LWfSFU3KNifvUW'),
  isTokenAutoRefreshEnabled: true,
});